import { PaddedSurface, WrapMdMarginBottom } from "App/global-style";
import {
  AlertTitle,
  Placeholder,
} from "Components/TextContext/commonComponentEnums";
import React, { ElementType, Fragment } from "react";

import { lastThreeYearsAsOptions } from "Components/Features/CheckPrice/Products/RiskProducts/riskProductsUtils";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { Select } from "Components/Form/Select";
import { useTexts } from "Components/TextContext";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { AppDefinedVariables } from "Components/TextContext/textInterfaces";
import { getCollectionOfDittoComponents } from "Components/TextContext/utils/getCollectionOfDittoComponents";
import { getProductSpecificComponentText } from "Components/TextContext/utils/getProductSpecificComponentText";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import { ContactUsAlert } from "../Alert";
import { RadioButton } from "../RadioButton";
import { DamageRecentYears } from "./recentDamagesInterfaces";

interface Props {
  formProps: FormikProps<any>;
  onBlur?: () => void;
  productName: ProductBackendName;
  withSurface?: boolean;
  appDefinedVariables?: AppDefinedVariables;
  injuryYearLabel?: string;
}

export const RecentDamages = ({
  formProps,
  onBlur,
  productName,
  withSurface,
  appDefinedVariables,
  injuryYearLabel,
}: Props): React.ReactElement => {
  const { getText, getRadioOptions } = useTexts();
  const { label: recentDamagesLabels } = getCollectionOfDittoComponents(
    TextComponentNameLevel1.RECENT_DAMAGES,
  );

  const injuries = formProps.values.injuries;

  const renderFormElements = (Parent: ElementType): React.ReactElement => (
    <Parent>
      <RadioButton
        name="injuries"
        id="injuries"
        label={getProductSpecificComponentText(
          productName,
          recentDamagesLabels,
          "injuries",
          appDefinedVariables,
        )}
        options={getRadioOptions(
          TextComponentNameLevel1.RECENT_DAMAGES,
          "injuries",
        )}
        direction="vertical"
        error={getError("injuries", formProps)}
        onChange={() => {
          formProps.setFieldTouched("injuryYear", false);
        }}
        onBlur={onBlur}
      />
      {injuries === DamageRecentYears.ONE && (
        <Select
          large
          id="injuryYear"
          name="injuryYear"
          label={
            injuryYearLabel
              ? injuryYearLabel
              : getText("recentdamages.label.injuryyear")
          }
          options={lastThreeYearsAsOptions(getText(Placeholder.CHOOSE_YEAR))}
          error={getError("injuryYear", formProps)}
          onBlur={onBlur}
        />
      )}
    </Parent>
  );

  return (
    <>
      {renderFormElements(withSurface ? PaddedSurface : Fragment)}

      {productName !== ProductBackendName.ANIMAL &&
        injuries === DamageRecentYears.TWO_OR_MORE && (
          <WrapMdMarginBottom>
            <ContactUsAlert
              variant="border"
              description={getText(
                "recentdamages.validation.injuries-maxdamages",
              )}
              title={getText(AlertTitle.CALL_US)}
              alertId="injuries"
            />
          </WrapMdMarginBottom>
        )}
    </>
  );
};
